export default {
  baseUrl: 'https://api.martin-legrand.com/',
  passwordProtected: true
  //baseUrl: 'http://localhost:8888',
}